import graphql from "babel-plugin-relay/macro";

const StockDetailByIdQuery = graphql`
query StockDetailByIdQuery($id:ID){
  allPoliticians(id:$id){
    edges{
      node{
        id
        name
        politicianImage
        
        dob
        birthplace
        age
        education
        currentPosition
        almaMater  
        upcoming
        upcomingStocks
        upcomingStocksUsed 
        upcomingStocksPercentage 
        upcomingStocksSubscribed    
        party{
          id
          partyName
          partyImage
        }
        tags
        region{
          regionName
        }
        price
        rank
        relatedPoliticians{
          edges{
            node{
              id
              name
              politicianImage
              price
             
              stockhistory{
                edges{
                  node{
                    created                    
                    updatedPrice               
                    
                  }
                }
              }
            }
          }
        }
        totalShare
        openShare
        lockedShares
        marketCap
        almaMater
        purchaseCap
        buy
        sell
        hold
        buySellHold
       
        politicianassets{
          edges{
            node{
              totalAssets
              immovableAssets
              movableAssets
              investments
            }
          }
        }
        politiciantimelines{
          edges{
            node{
              id
              year
              govt
              workedAs
            }
          }
        }
      }
    }
  }
}
`

export default StockDetailByIdQuery;
// stockOwnedCount
// priceDiff
// priceDiffPercentage
// priceDiff
// stockLowValue
//         stockHighValue
//         stockHighValueLongTerm
//         stockLowValueLongTerm